exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gradient-overlay[data-v-5c2a760e]{position:absolute;left:0;top:0;right:0;bottom:0;background:linear-gradient(180deg,rgba(21,21,22,0),#151516)}@media screen and (min-width:1280px){.gradient-overlay[data-v-5c2a760e]{background:linear-gradient(180deg,rgba(21,21,22,0) 50%,#151516)}}.gradient-wrapper[data-v-5c2a760e]{background:linear-gradient(180deg,rgba(21,21,22,0) 34%,#434d57)}", ""]);

// exports
